import React, { Component } from "react";
import { MissionService } from "../generated";
import { Table } from "reactstrap";
import { LoggedRequest } from "../generated/models/LoggedRequest";
import { LoggedResponse } from "../generated/models/LoggedResponse";

export interface Props {}

export interface State {
  zippedLogs: Array<[LoggedRequest, LoggedResponse]>;
}

export class RequestResponseResults extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      zippedLogs: null,
    };
  }

  async componentDidMount() {
    const data = await MissionService.getRequestResponseLogs();
    this.setState({
      zippedLogs: zip(data.requests, data.responses),
    });
  }

  render() {
    return (
      <>
        {this.state.zippedLogs != null && (
          <div className="border rounded p-5">
            <RequestResponseTable zippedLogs={this.state.zippedLogs} />
          </div>
        )}
        {this.state.zippedLogs == null && <></>}
      </>
    );
  }
}

function zip<S1, S2>(
  firstCollection: Array<S1>,
  lastCollection: Array<S2>
): Array<[S1, S2]> {
  const length = Math.min(firstCollection.length, lastCollection.length);
  const zipped: Array<[S1, S2]> = [];

  for (let index = 0; index < length; index++) {
    zipped.push([firstCollection[index], lastCollection[index]]);
  }
  return zipped;
}

type RequestResponseLogsTableProps = {
  zippedLogs: Array<[LoggedRequest, LoggedResponse]>;
};

function RequestResponseTable({
  zippedLogs,
}: RequestResponseLogsTableProps): JSX.Element {
  return (
    <Table responsive style={{ tableLayout: "fixed", wordWrap: "break-word" }}>
      <thead>
        <tr>
          <th>Requests</th>
          <th>Responses</th>
        </tr>
      </thead>
      <tbody>
        {zippedLogs.map((logPair) => (
          <LogPairRow logPair={logPair} />
        ))}
      </tbody>
    </Table>
  );
}

type LogPairProps = {
  logPair: [LoggedRequest, LoggedResponse];
};

function LogPairRow({ logPair }: LogPairProps): JSX.Element {
  const prettyPrint = (input: string) =>
    JSON.stringify(JSON.parse(input ?? null), null, 4);

  const req = logPair[0];
  const res = logPair[1];

  return (
    <tr>
      <td>
        Url: <span style={{ overflowWrap: "break-word" }}>{req.url}</span>{" "}
        <br />
        {req.data != null && (
          <details>
            <summary>Request body</summary>
            <pre>{prettyPrint(req.data)}</pre>
          </details>
        )}
      </td>
      <td>
        Status: {res.status}
        {res.data != null && (
          <details>
            <summary>Response body</summary>
            <pre>{prettyPrint(res.data)}</pre>
          </details>
        )}
      </td>
    </tr>
  );
}
